(()=>{'use strict';
const KEY='moga_theme_builder_v2',APP='moga_app_settings_v2';
const $=(s,r=document)=>r.querySelector(s),$$=(s,r=document)=>Array.from(r.querySelectorAll(s));
const esc=s=>String(s??'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
const PAGES=[
 ['invoice','SĄSKAITA','#invoiceSheet',1],['overview','APŽVALGA','#overviewSheet'],['stats','SUVESTINĖ','#statsSheet'],['warehouse','SANDĖLIS','#warehouseSheet'],['purchases','PIRKIMAI','#purchaseSheet'],['accountingSales','PARDAVIMAI','#accountingSalesSheet'],['expenses','IŠLAIDOS','#expenseSheet'],['tasks','UŽDUOTYS','#taskSheet'],['manufacturing','GAMYBA','#moga-manufacturing-sheet'],['services','PASLAUGOS','#moga-services-sheet'],['tracking','SEKIMO INFO','#trackingSheet'],['orders','UŽSAKYMAI','#moga-orders-sheet,#ordersSheet']
].map(x=>({key:x[0],label:x[1],selector:x[2],locked:!!x[3]}));
const GROUPS=[
 ['PUSLAPIO FONAS',[['bg','Pagrindinis fonas','#fffaf5'],['glowLeft','Kairysis glow','#ffe3bd'],['glowRight','Dešinysis glow','#ffdce6'],['border','Rėmeliai / linijos','#decbb9']]],
 ['TEKSTAI',[['title','Antraštės','#FFFFFF'],['text','Pagrindinis tekstas','#FFFFFF'],['formText','Įvedamas / laukelių tekstas','#FFFFFF'],['muted','Antrinis tekstas','#A0A0A0'],['labelText','Laukelių pavadinimai','#FFFFFF'],['link','Nuorodos','#0969da']]],
 ['KORTELĖS / BLOKAI',[['cardBg','Kortelių fonas','#fffdfb'],['cardText','Kortelių tekstas','#171717']]],
 ['LAUKELIAI · NEAKTYVŪS',[['inputBg','Fonas','#ffffff'],['inputText','Tekstas','#171717'],['placeholder','Placeholder','#777777'],['inputBorder','Rėmelis','#bbbbbb']]],
 ['LAUKELIAI · AKTYVŪS',[['focusBg','Fonas','#ffffff'],['focusText','Vedamas tekstas','#111111'],['focusPlaceholder','Placeholder','#888888'],['focusBorder','Rėmelis','#ff8a00']]],
 ['PAGRINDINIAI MYGTUKAI',[['primary1','Kairė spalva','#ff8a00'],['primary2','Dešinė spalva','#ff4f91'],['primaryText','Tekstas','#111111']]],
 ['NEUTRALŪS MYGTUKAI',[['neutral1','Fonas 1','#ffffff'],['neutral2','Fonas 2','#f1eee9'],['neutralText','Tekstas','#171717'],['neutralBorder','Rėmelis','#c9b9a9']]],
 ['TABAI / SKILTYS',[['tabBg','Neaktyvus fonas','#ffffff'],['tabText','Neaktyvus tekstas','#171717'],['tabActive1','Aktyvus · kairė','#ff8a00'],['tabActive2','Aktyvus · dešinė','#ff4f91'],['tabActiveText','Aktyvus tekstas','#111111']]],
 ['LENTELĖS',[['tableHeadBg','Antraštės fonas','#202020'],['tableHeadText','Antraštės tekstas','#ffffff'],['tableHeadBorder','Antraštės linijos','#444444'],['tableBg','Eilučių fonas','#ffffff'],['tableAlt','Kas antros eilutės','#fafafa'],['tableText','Eilučių tekstas','#171717'],['tableBorder','Eilučių linijos','#d4d4d4']]],
 ['INFO / APATINĖS ZONOS',[['footerBg','Fonas','#f7f3ee'],['footerText','Tekstas','#555555']]]
];
const TRACK=['SEKIMO INFO · BŪSENOS',[['paidBg','Apmokėta · fonas','#dff3df'],['paidText','Apmokėta · tekstas','#111111'],['unpaidBg','Neapmokėta · fonas','#ffdede'],['unpaidText','Neapmokėta · tekstas','#111111'],['partialBg','Dalinai · fonas','#fff1c7'],['partialText','Dalinai · tekstas','#111111'],['overdueBg','Vėluoja · fonas','#f7c7c7'],['overdueText','Vėluoja · tekstas','#111111']]];
const TEXT_RANGES=[['inputFontSize','Laukelių tekstas / placeholderiai',9,18,1,12,' px']];
const RANGES=[['radius','Kampų apvalinimas',0,30,1,18,' px'],['shadow','Šešėlio gylis',0,40,1,22,'']];
let state={version:2,pages:{},globalInputFontSize:12},current='tracking',zoom=62,timer=0,previewMode='page';
function getApp(){try{return JSON.parse(localStorage.getItem(APP)||'{}')||{}}catch(_){return{}}}
function baseDefaults(){const a=getApp(),o={};GROUPS.forEach(g=>g[1].forEach(x=>o[x[0]]=x[2]));TEXT_RANGES.forEach(x=>o[x[0]]=x[5]);RANGES.forEach(x=>o[x[0]]=x[5]);Object.assign(o,{primary1:a.accentColor||o.primary1,primary2:a.accentColor2||o.primary2,paidBg:a.paidColor||'#dff3df',unpaidBg:a.unpaidColor||'#ffdede',partialBg:a.partialColor||'#fff1c7',overdueBg:a.overdueColor||'#f7c7c7'});TRACK[1].forEach(x=>{if(o[x[0]]==null)o[x[0]]=x[2]});return o}
function defaults(k){return Object.assign({},baseDefaults())}
function load(){
  try{const x=JSON.parse(localStorage.getItem(KEY)||'null');if(x?.pages)state=x}catch(_){}
  state.globalInputFontSize=Math.max(9,Math.min(18,Number(state.globalInputFontSize)||12));
  PAGES.forEach(p=>state.pages[p.key]=Object.assign(defaults(p.key),state.pages[p.key]||{}));
  applyGlobalInputFontSize();
}
function syncLegacy(){try{const a=getApp(),s=state.pages.tracking;a.uiTheme='luxury';a.accentColor=s.primary1;a.accentColor2=s.primary2;a.paidColor=s.paidBg;a.unpaidColor=s.unpaidBg;a.partialColor=s.partialBg;a.overdueColor=s.overdueBg;localStorage.setItem(APP,JSON.stringify(a))}catch(_){}}
function save(){syncLegacy();try{localStorage.setItem(KEY,JSON.stringify(state));setStatus('IŠSAUGOTA ✓')}catch(e){setStatus('NEPAVYKO IŠSAUGOTI')}}
function schedule(){setStatus('SAUGOMA…');clearTimeout(timer);timer=setTimeout(save,100)}function setStatus(t){const e=$('#mtbSave');if(e)e.textContent=t}
function forceIndividual(){try{const a=getApp();if(a.uiTheme!=='luxury'){a.uiTheme='luxury';localStorage.setItem(APP,JSON.stringify(a));if(typeof window.applyAppSettings==='function')window.applyAppSettings(a)}}catch(_){}document.body.classList.remove('theme-dark','theme-light');document.body.classList.add('theme-luxury')}
function varName(k){return '--m-'+k.replace(/[A-Z]/g,m=>'-'+m.toLowerCase())}
function applyGlobalInputFontSize(){
  const v=Math.max(9,Math.min(18,Number(state.globalInputFontSize)||12));
  document.documentElement.style.setProperty('--m-global-input-font-size',v+'px');
}
function pageEl(k){const p=PAGES.find(x=>x.key===k);return p?$(p.selector):null}
function applyVars(el,k){
  if(!el||k==='invoice')return;
  el.dataset.mogaThemePage=k;
  const s=state.pages[k]||defaults(k);
  Object.entries(s).forEach(([a,v])=>{
    const out=a==='inputFontSize' ? `${Number(v)||12}px` : v;
    el.style.setProperty(varName(a),out);
  });
  el.style.setProperty('--accent',s.primary1);
  el.style.setProperty('--accent2',s.primary2);
  el.style.setProperty('--accent-gradient',`linear-gradient(90deg,${s.primary1},${s.primary2})`);
  if(k==='tracking'){
    el.style.setProperty('--paid-color',s.paidBg);
    el.style.setProperty('--unpaid-color',s.unpaidBg);
    el.style.setProperty('--partial-color',s.partialBg);
    el.style.setProperty('--overdue-color',s.overdueBg);
  }
}
function ensureLabelThemeCss(){
  if(document.getElementById('mogaThemeBuilderLabelCss'))return;
  const st=document.createElement('style');st.id='mogaThemeBuilderLabelCss';
  st.textContent=`
    [data-moga-theme-page] label,
    [data-moga-theme-page] .field-label,
    [data-moga-theme-page] .form-label,
    .moga-theme-modal-scope label,
    .moga-theme-modal-scope .field-label,
    .moga-theme-modal-scope .form-label{
      color:var(--m-label-text,#fff)!important;
      -webkit-text-fill-color:var(--m-label-text,#fff)!important;
    }
    [data-moga-theme-page] input,
    [data-moga-theme-page] textarea,
    [data-moga-theme-page] select,
    .moga-theme-modal-scope input,
    .moga-theme-modal-scope textarea,
    .moga-theme-modal-scope select{
      color:var(--m-form-text,#fff)!important;
      -webkit-text-fill-color:var(--m-form-text,#fff)!important;
    }
    [data-moga-theme-page] input::placeholder,
    [data-moga-theme-page] textarea::placeholder,
    .moga-theme-modal-scope input::placeholder,
    .moga-theme-modal-scope textarea::placeholder{
      color:var(--m-muted,#a0a0a0)!important;
      -webkit-text-fill-color:var(--m-muted,#a0a0a0)!important;
      opacity:1!important;
    }
    .moga-theme-modal-scope h1,.moga-theme-modal-scope h2,.moga-theme-modal-scope h3,
    .moga-theme-modal-scope .task-modal-head,
    .moga-theme-modal-scope .task-view-head h3{
      color:var(--m-title,#fff)!important;
      -webkit-text-fill-color:var(--m-title,#fff)!important;
    }`;
  document.head.appendChild(st);
}
function applyAll(){ensureLabelThemeCss();PAGES.forEach(p=>applyVars(pageEl(p.key),p.key));scopeAllModals();cleanupSettingsThemeLeak()}
function activeKey(){const b=$('#sidePages>button.active'),m=String(b?.getAttribute('onclick')||'').match(/switchPage\(['\"]([^'\"]+)/);return m?.[1]||'invoice'}

function modalPageKey(el){
  const id=String(el?.id||'');
  const cls=String(el?.className||'');

  const explicit={
    purchaseOrderModal:'purchases',
    supplierModal:'purchases',
    supplierLinkModal:'purchases',
    receiptModal:'purchases',
    accountingImportModal:'purchases',
    expenseModal:'expenses',
    taskModal:'tasks',
    taskViewModal:'tasks',
    inventoryModal:'warehouse',
    mogaProduceRecipeModal:'manufacturing'
  };
  if(explicit[id])return explicit[id];

  if(/\bpo-new-product-overlay\b/.test(cls))return 'purchases';
  if(/\btask-view-modal\b/.test(cls))return 'tasks';
  if(/\bmoga-produce-modal\b/.test(cls))return 'manufacturing';

  // Generic/global modalai (Help, Welcome, Shopify sync, MOGA_UI alert ir pan.)
  // spalvų redaktoriaus puslapiams nepriskiriami.
  return '';
}
function isSettingsUi(el){
  if(!el)return false;
  const id=String(el.id||'').toLowerCase();
  const cls=String(el.className||'').toLowerCase();
  return id==='settingspanel'||id==='settingsmodal'||cls.includes('settings-panel')||cls.includes('settings-window')||cls.includes('settings-modal');
}
function isThemeableModal(el){
  if(!el||el.closest?.('#mogaThemeBuilder')||isSettingsUi(el))return false;
  return el.matches?.(
    '.purchase-modal,.expense-modal,.task-modal,.inventory-modal,.supplier-modal,'+
    '.moga-biz-modal,.moga-produce-modal,.po-new-product-overlay,[role="dialog"]'
  );
}
function applyModalVars(el,k){
  if(!el||!k||k==='invoice')return;
  const s=state.pages[k]||defaults(k);
  Object.entries(s).forEach(([a,v])=>{
    const out=a==='inputFontSize'?`${Number(v)||12}px`:v;
    el.style.setProperty(varName(a),out);
  });
  el.style.setProperty('--accent',s.primary1);
  el.style.setProperty('--accent2',s.primary2);
  el.style.setProperty('--accent-gradient',`linear-gradient(90deg,${s.primary1},${s.primary2})`);
  el.classList.add('moga-theme-modal-scope');
  el.dataset.mogaThemeOwner=k;
}
function scopeModal(el){
  if(!isThemeableModal(el))return;
  const k=modalPageKey(el);
  if(!k||k==='invoice')return;
  // Modalui perduodam spalvų kintamuosius, bet NE pažymim kaip pilną SFAPP puslapį.
  // Taip fullscreen overlay negauna puslapio fono/glow ir nesusigadina bendras vaizdas.
  el.removeAttribute('data-moga-theme-page');
  applyModalVars(el,k);
}
function cleanupSettingsThemeLeak(){
  document.querySelectorAll('#settingsPanel,.settings-panel,.settings-window,.settings-modal').forEach(el=>{
    el.classList.remove('moga-theme-modal-scope');
    el.removeAttribute('data-moga-theme-page');
    el.removeAttribute('data-moga-theme-owner');
    [...el.style].filter(n=>n.startsWith('--m-')||n==='--accent'||n==='--accent2'||n==='--accent-gradient').forEach(n=>el.style.removeProperty(n));
  });
}
function scopeAllModals(){
  cleanupSettingsThemeLeak();
  document.querySelectorAll(
    '.purchase-modal,.expense-modal,.task-modal,.inventory-modal,.supplier-modal,'+
    '.moga-biz-modal,.moga-produce-modal,.po-new-product-overlay,[role="dialog"]'
  ).forEach(scopeModal);
}
let __mogaModalScopeRaf=0;
function scheduleModalScope(){
  cancelAnimationFrame(__mogaModalScopeRaf);
  __mogaModalScopeRaf=requestAnimationFrame(scopeAllModals);
}


function resetPage(){
  if(current==='invoice')return;
  if(!confirm('Atkurti numatytas šio lango spalvas?'))return;
  state.pages[current]=defaults(current);
  save();
  applyAll();
  select(current);
}
function resetAll(){
  if(!confirm('Atkurti numatytus VISŲ SFAPP langų nustatymus?'))return;
  state.pages={};
  state.globalInputFontSize=12;
  PAGES.forEach(p=>state.pages[p.key]=defaults(p.key));
  applyGlobalInputFontSize();
  save();
  applyAll();
  select(current);
}

function mount(){if($('#mogaThemeBuilder'))return;const e=document.createElement('div');e.id='mogaThemeBuilder';e.innerHTML=`<div class="mtb-shell"><div class="mtb-head"><div><div class="mtb-kicker">MOGA SF · INDIVIDUALI TEMA</div><h2>SPALVŲ REDAKTORIUS</h2></div><div class="mtb-head-right"><button class="mtb-btn" id="mtbExport">EKSPORTUOTI</button><button class="mtb-btn" id="mtbImport">IMPORTUOTI</button><input class="mtb-file" id="mtbImportFile" type="file" accept=".json,application/json"><button class="mtb-x" id="mtbX">×</button></div></div><div class="mtb-main"><aside class="mtb-pages"><div class="mtb-pages-label">SFAPP LANGAI</div><div id="mtbPages"></div></aside><section class="mtb-editor"><div class="mtb-editor-head"><b id="mtbTitle"></b><small id="mtbSub"></small></div><div id="mtbControls"></div></section><section class="mtb-preview-col"><div class="mtb-preview-bar"><b>LIVE PERŽIŪRA</b><span>Keitimai matomi iš karto.</span><label class="mtb-preview-mode-wrap">RODYTI <select id="mtbPreviewMode"><option value="page">PUSLAPĮ</option></select></label><label class="mtb-preview-zoom">ZOOM <input id="mtbZoom" type="range" min="35" max="100" value="62"></label></div><div class="mtb-stage" id="mtbStage"><iframe id="mtbFrame" class="mtb-frame"></iframe><div class="mtb-hint">LIVE · pakeitimai matomi iš karto</div></div></section></div><div class="mtb-foot"><span id="mtbSave" class="mtb-save">IŠSAUGOTA ✓</span><button class="mtb-btn" id="mtbReset">ATKURTI ŠĮ LANGĄ</button><button class="mtb-btn danger" id="mtbResetAll">ATKURTI VISKĄ</button><button class="mtb-btn gold" id="mtbDone">BAIGTI</button></div></div>`;e.addEventListener('click',x=>{if(x.target===e)close()});document.body.appendChild(e);$('#mtbX').onclick=close;$('#mtbDone').onclick=close;$('#mtbReset').onclick=resetPage;$('#mtbResetAll').onclick=resetAll;$('#mtbExport').onclick=exportTheme;$('#mtbImport').onclick=()=>$('#mtbImportFile').click();$('#mtbImportFile').onchange=importTheme;$('#mtbZoom').oninput=x=>{zoom=Number(x.target.value);setPreviewZoom()};$('#mtbPreviewMode').onchange=x=>{previewMode=x.target.value||'page';renderPreviewModes();buildPreview()};}
function renderPages(){const box=$('#mtbPages');box.innerHTML=PAGES.map(p=>{const exists=!!pageEl(p.key);return `<button class="mtb-page ${p.key===current?'active':''} ${!exists&&!p.locked?'unavailable':''} ${p.locked?'locked':''}" data-k="${esc(p.key)}"><span>${esc(p.label)}</span><i class="mtb-page-dot"></i></button>`}).join('');$$('.mtb-page',box).forEach(b=>b.onclick=()=>select(b.dataset.k))}
function row(k,l){const v=state.pages[current][k];return `<div class="mtb-color"><label>${esc(l)}</label><input type="color" data-c="${k}" value="${v}"><input type="text" data-h="${k}" value="${v}" maxlength="7"></div>`}
function controls(){
  if(current==='invoice')return `<div class="mtb-empty"><b>SĄSKAITA</b><br><br>Čia spalvų nekeičiam. Sąskaita ir jos PDF / spausdinimo maketas lieka stabilus.</div>`;
  let gs=[...GROUPS];if(current==='tracking')gs.push(TRACK);
  const modalCount=modalCandidates(current).length;
  let h=`<details class="mtb-group" open><summary>LIVE PERŽIŪRA</summary><div class="mtb-group-body"><label class="mtb-side-preview-label">Ką rodyti<select id="mtbPreviewModeSide">${previewOptionsHtml()}</select></label><div class="mtb-side-preview-note">${modalCount?`Rasta modalų: <b>${modalCount}</b>`:'Šiam langui atskiro modalo nerasta.'}</div></div></details>`;
  h+=`<details class="mtb-group" open><summary>TEKSTO DYDIS</summary><div class="mtb-group-body">${TEXT_RANGES.map(x=>`<div class="mtb-range"><label><span>${x[1]}</span><b data-rv="${x[0]}">${state.pages[current][x[0]]}${x[6]}</b></label><input type="range" data-r="${x[0]}" min="${x[2]}" max="${x[3]}" step="${x[4]}" value="${state.pages[current][x[0]]}" data-s="${x[6]}"></div>`).join('')}<button type="button" class="mtb-apply-text-all" id="mtbApplyTextAll">TAIKYTI DYDĮ VISIEMS LANGAMS</button></div></details>`;
  h+=gs.map((g,i)=>`<details class="mtb-group" ${i<3?'open':''}><summary>${g[0]}</summary><div class="mtb-group-body">${g[1].map(x=>row(x[0],x[1])).join('')}</div></details>`).join('');
  h+=`<details class="mtb-group"><summary>FORMA / GYLIS</summary><div class="mtb-group-body">${RANGES.map(x=>`<div class="mtb-range"><label><span>${x[1]}</span><b data-rv="${x[0]}">${state.pages[current][x[0]]}${x[6]}</b></label><input type="range" data-r="${x[0]}" min="${x[2]}" max="${x[3]}" step="${x[4]}" value="${state.pages[current][x[0]]}" data-s="${x[6]}"></div>`).join('')}</div></details>`;
  return h;
}
function applyTextSizeEverywhere(){
  const v=Math.max(9,Math.min(18,Number(state.pages[current]?.inputFontSize)||12));
  state.globalInputFontSize=v;
  PAGES.forEach(p=>{
    if(p.locked)return;
    state.pages[p.key]=state.pages[p.key]||defaults(p.key);
    state.pages[p.key].inputFontSize=v;
  });
  applyGlobalInputFontSize();
  save();
  applyAll();
  syncPreview();
  const b=$('#mtbApplyTextAll');
  if(b){const old=b.textContent;b.textContent='PRITAIKYTA ✓';setTimeout(()=>{if(b)b.textContent=old},900)}
}
function bind(){$$('[data-c]').forEach(i=>i.oninput=()=>{const k=i.dataset.c;state.pages[current][k]=i.value;const h=$(`[data-h="${k}"]`);if(h)h.value=i.value.toUpperCase();changed()});$$('[data-h]').forEach(i=>i.onchange=()=>{let v=i.value.trim();if(!v.startsWith('#'))v='#'+v;if(!/^#[0-9a-f]{6}$/i.test(v)){i.value=state.pages[current][i.dataset.h];return}state.pages[current][i.dataset.h]=v;const c=$(`[data-c="${i.dataset.h}"]`);if(c)c.value=v;changed()});$$('[data-r]').forEach(i=>i.oninput=()=>{state.pages[current][i.dataset.r]=Number(i.value);$(`[data-rv="${i.dataset.r}"]`).textContent=i.value+(i.dataset.s||'');changed()});const ta=$('#mtbApplyTextAll');if(ta)ta.onclick=applyTextSizeEverywhere;
const pm=$('#mtbPreviewModeSide');if(pm)pm.onchange=e=>{previewMode=e.target.value||'page';renderPreviewModes();buildPreview()}
}

function modalCandidates(pageKey=current){
  const defs=[
    {id:'purchaseOrderModal',key:'purchases',label:'PIRKIMO UŽSAKYMAS',window:'.purchase-modal-window'},
    {id:'supplierModal',key:'purchases',label:'NAUJAS TIEKĖJAS',window:'.purchase-modal-window'},
    {id:'supplierLinkModal',key:'purchases',label:'SUSIETI TIEKĖJO PREKĘ',window:'.purchase-modal-window'},
    {id:'receiptModal',key:'purchases',label:'PREKIŲ PRIĖMIMAS',window:'.purchase-modal-window'},
    {id:'accountingImportModal',key:'purchases',label:'PDF APSKAITOS IMPORTAS',window:'.purchase-modal-window'},
    {id:'expenseModal',key:'expenses',label:'NAUJA IŠLAIDA',window:'.purchase-modal-window'},
    {id:'taskModal',key:'tasks',label:'NAUJA / REDAGUOTI UŽDUOTĮ',window:'.task-modal-window'},
    {id:'taskViewModal',key:'tasks',label:'UŽDUOTIES INFORMACIJA',window:'.task-view-window'},
    {id:'inventoryModal',key:'warehouse',label:'SANDĖLIO PREKĖ',window:'.inventory-modal-window'},
    {id:'mogaProduceRecipeModal',key:'manufacturing',label:'PAGAMINTI GAMINĮ',window:'.moga-produce-window'}
  ];
  const out=[];
  defs.forEach(d=>{
    if(d.key!==pageKey)return;
    const el=document.getElementById(d.id);
    if(el)out.push({el,label:d.label,pageKey:d.key,windowSelector:d.window});
  });

  // Naujos prekės pirkime modalas gali būti kuriamas dinamiškai be pastovaus ID.
  if(pageKey==='purchases'){
    const el=document.querySelector('.po-new-product-overlay');
    if(el)out.push({el,label:'NAUJA SFAPP PREKĖ',pageKey:'purchases',windowSelector:'.po-new-product-modal,.po-new-product-card'});
  }
  return out;
}
function previewOptionsHtml(){
  const mods=modalCandidates(current);
  if(current==='tasks') return `<option value="page">REALIAME LANGE</option>`;
  return `<option value="page">PAGRINDINIS LANGAS</option>`+
    mods.map((m,i)=>`<option value="modal:${i}">${esc(m.label.slice(0,42))}</option>`).join('');
}
function renderPreviewModes(){
  const selects=[$('#mtbPreviewMode'),$('#mtbPreviewModeSide')].filter(Boolean);
  const html=previewOptionsHtml();
  selects.forEach(s=>{
    s.innerHTML=html;
    if(!Array.from(s.options).some(o=>o.value===previewMode))previewMode='page';
    s.value=previewMode;
  });
}
function select(k){
  const previous=current;
  current=k;
  // Keičiant pagrindinį SFAPP langą visada pradėti nuo paties puslapio.
  // Modalo peržiūra pasirenkama tik sąmoningai per "LIVE PERŽIŪRA" selectą.
  if(previous!==k)previewMode='page';
  renderPages();
  const p=PAGES.find(x=>x.key===k),exists=!!pageEl(k);
  $('#mtbTitle').textContent=p.label;
  $('#mtbSub').textContent=p.locked?'Nekeičiama · PDF saugumas':exists?'LIVE · realus SFAPP langas':'Modulis šiuo metu išjungtas / nerastas, bet spalvos bus išsaugotos';
  $('#mtbControls').innerHTML=controls();
  bind();
  renderPreviewModes();
  buildPreview();
}
function changed(){
  applyVars(pageEl(current),current);
  scopeAllModals();
  syncPreview();
  schedule();
  requestAnimationFrame(()=>{
    applyVars(pageEl(current),current);
    scopeAllModals();
    syncPreview();
  });
}
function styleVars(s){return Object.entries(s).map(([k,v])=>`${varName(k)}:${k==='inputFontSize'?(Number(v)||12)+'px':v}`).join(';')+`;--accent:${s.primary1};--accent2:${s.primary2};--accent-gradient:linear-gradient(90deg,${s.primary1},${s.primary2})`}
function trimClone(c){c.querySelectorAll('tbody').forEach(tb=>Array.from(tb.children).slice(6).forEach(x=>x.remove()));c.querySelectorAll('.modal,.moga-modal,[role="dialog"],script').forEach(x=>x.remove());return c}
function allStyles(){return $$('link[rel="stylesheet"]').map(l=>`<link rel="stylesheet" href="${esc(l.href)}">`).join('')}
function fallback(p){return `<div data-moga-theme-page="${p.key}" style="${styleVars(state.pages[p.key])};width:1100px;min-height:700px;padding:22px"><h2>${p.label}</h2><div class="muted" style="margin:6px 0 18px">Modulis šiuo metu išjungtas. Spalvos išsisaugos ir bus pritaikytos jį įjungus.</div><div style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px">${[1,2,3,4].map(n=>`<div class="stat-card"><span>Informacija</span><strong>Kortelė ${n}</strong></div>`).join('')}</div><div style="display:flex;gap:8px;margin:16px 0"><input placeholder="Laukelio pavyzdys"><button class="gold">PAGRINDINIS</button><button>NEUTRALUS</button></div><table style="width:100%;border-collapse:collapse"><thead><tr><th>Nr.</th><th>Pavadinimas</th><th>Būsena</th></tr></thead><tbody><tr><td>1</td><td>MOGA pavyzdys</td><td>Aktyvu</td></tr><tr><td>2</td><td>Antra eilutė</td><td>—</td></tr></tbody></table></div>`}
function buildPreview(){
  const p=PAGES.find(x=>x.key===current),f=$('#mtbFrame');
  if(p.locked){
    const d=`<!doctype html><html><body style="margin:0;background:#bbb;font-family:Arial"><div style="margin:80px auto;width:650px;background:#fff;border-radius:18px;padding:35px;text-align:center;box-shadow:0 20px 60px #0003"><h2>SĄSKAITA</h2><p style="color:#666">Sąskaitos dizainas šiame spalvų redaktoriuje nekeičiamas.</p></div></body></html>`;
    f.srcdoc=d;return;
  }

  let body='',modalPreview=false;
  if(String(previewMode).startsWith('modal:')){
    const idx=Number(String(previewMode).split(':')[1]);
    const m=modalCandidates(current)[idx];
    if(m?.el){
      const source=(m.windowSelector&&m.el.querySelector(m.windowSelector))||m.el;
      const c=source.cloneNode(true);
      c.removeAttribute('hidden');
      c.setAttribute('aria-hidden','false');
      c.classList.add('mtb-preview-modal-window');
      c.style.display='flex';
      c.style.visibility='visible';
      c.style.opacity='1';
      c.style.position='relative';
      c.style.inset='auto';
      c.style.transform='none';
      c.style.margin='0 auto';
      c.style.maxHeight='none';
      c.style.overflow='visible';
      body=`<div data-moga-theme-page="${esc(current)}" class="mtb-modal-theme-root" style="${styleVars(state.pages[current])}">${c.outerHTML}</div>`;
      modalPreview=true;
    }
  }

  if(!body){
    const el=pageEl(current);
    if(el){
      const c=trimClone(el.cloneNode(true));
      c.classList.add('active');c.style.display='block';c.dataset.mogaThemePage=current;
      c.setAttribute('style',(c.getAttribute('style')||'')+';'+styleVars(state.pages[current]));
      body=c.outerHTML;
    }else body=fallback(p);
  }

  const modalCss=modalPreview?`
    body.mtb-preview-body{
      padding:0!important;
      min-width:1280px!important;width:1280px!important;
      min-height:900px!important;
      position:relative!important;
    }
    .mtb-modal-theme-root{
      width:1280px!important;
      min-height:900px!important;
      margin:0!important;padding:0!important;
      background:transparent!important;
      position:relative!important;
    }
    /* Preview: pilnas tikro modalo overlay. Tik fixed -> absolute,
       kad iframe'e atrodytų taip pat kaip realiame SFAPP lange. */
    .mtb-modal-theme-root > .task-modal,
    .mtb-modal-theme-root > .task-view-modal,
    .mtb-modal-theme-root > .purchase-modal,
    .mtb-modal-theme-root > .expense-modal,
    .mtb-modal-theme-root > .inventory-modal,
    .mtb-modal-theme-root > .supplier-modal,
    .mtb-modal-theme-root > .moga-produce-modal,
    .mtb-modal-theme-root > .po-new-product-overlay{
      display:flex!important;
      position:absolute!important;
      inset:0!important;
      width:1280px!important;
      min-height:900px!important;
      visibility:visible!important;
      opacity:1!important;
      align-items:center!important;
      justify-content:center!important;
      box-sizing:border-box!important;
    }
    .mtb-modal-theme-root .task-modal-window,
    .mtb-modal-theme-root .task-view-window,
    .mtb-modal-theme-root .purchase-modal-window,
    .mtb-modal-theme-root .inventory-modal-window,
    .mtb-modal-theme-root .moga-produce-window{
      transform:none!important;
    }`:`body.mtb-preview-body{padding:18px!important;min-width:1280px!important;width:1280px!important;max-width:none!important}`;

  const d=`<!doctype html><html><head><meta charset="utf-8"><base href="${esc(document.baseURI)}">${allStyles()}<style>
    html,body{margin:0!important;background:#b9b9b9!important;overflow:visible!important}
    ${modalCss}
    [data-moga-theme-page] label,
    [data-moga-theme-page] .field-label,
    [data-moga-theme-page] .form-label{
      color:var(--m-label-text,#fff)!important;
      -webkit-text-fill-color:var(--m-label-text,#fff)!important;
    }
    [data-moga-theme-page] input,[data-moga-theme-page] textarea,[data-moga-theme-page] select{
      color:var(--m-form-text,#fff)!important;
      -webkit-text-fill-color:var(--m-form-text,#fff)!important;
    }
    [data-moga-theme-page] input::placeholder,[data-moga-theme-page] textarea::placeholder{
      color:var(--m-muted,#a0a0a0)!important;
      -webkit-text-fill-color:var(--m-muted,#a0a0a0)!important;opacity:1!important;
    }
    [data-moga-theme-page] h1,[data-moga-theme-page] h2,[data-moga-theme-page] h3,
    [data-moga-theme-page] .task-view-head h3{
      color:var(--m-title,#fff)!important;
      -webkit-text-fill-color:var(--m-title,#fff)!important;
    }
  </style></head><body class="theme-luxury mtb-preview-body">${body}</body></html>`;
  f.srcdoc=d;
  f.onload=()=>{preparePreviewFrame(f,false);setPreviewZoom();syncPreview()};
}
function preparePreviewFrame(frame,isMagnifier){
  try{
    const d=frame.contentDocument;if(!d)return;
    const root=d.querySelector('[data-moga-theme-page]');
    if(root){
      root.style.width='1180px';
      root.style.maxWidth='none';
      root.style.margin='0 auto';
      root.style.display='block';
      root.style.setProperty('--m-input-font-size',(Number(state.pages[current]?.inputFontSize)||12)+'px');
    }
    d.documentElement.style.width='1280px';
    d.documentElement.style.minWidth='1280px';
    d.documentElement.style.maxWidth='none';
    d.documentElement.style.overflow='auto';
    if(d.body){
      d.body.style.width='1280px';
      d.body.style.minWidth='1280px';
      d.body.style.maxWidth='none';
      d.body.style.overflow='visible';
    }

    const fullH=Math.max(
      900,
      d.documentElement.scrollHeight,
      d.body?.scrollHeight||0,
      (root?.scrollHeight||0)+40
    );

    if(isMagnifier){
      frame.style.width='100%';
      frame.style.height='100%';
      frame.style.minWidth='0';
      frame.style.maxWidth='none';
      frame.style.transform='none';
      frame.style.transformOrigin='0 0';
    }else{
      frame.style.width='1280px';
      frame.style.maxWidth='none';
      frame.style.height=fullH+'px';
      frame.dataset.fullHeight=String(fullH);
    }
  }catch(_){}
}
function setPreviewZoom(){
  try{
    const f=$('#mtbFrame');if(!f)return;
    const s=zoom/100;
    f.style.width='1280px';f.style.maxWidth='none';f.style.transformOrigin='0 0';f.style.transform=`scale(${s})`;
  }catch(_){}
}
function syncPreview(){
  for(const id of ['#mtbFrame']){
    try{
      const fr=$(id),d=fr?.contentDocument,e=d?.querySelector('[data-moga-theme-page]');
      if(e){applyVars(e,current);e.setAttribute('style',(e.getAttribute('style')||'')+';'+styleVars(state.pages[current]))}
    }catch(_){}
  }
}
function exportTheme(){save();const b=new Blob([JSON.stringify(state,null,2)],{type:'application/json'}),u=URL.createObjectURL(b),a=document.createElement('a');a.href=u;a.download='MOGA_SF_TEMA_'+new Date().toISOString().slice(0,10)+'.json';a.click();setTimeout(()=>URL.revokeObjectURL(u),1000)}function importTheme(e){const f=e.target.files?.[0];if(!f)return;const r=new FileReader();r.onload=()=>{try{const x=JSON.parse(r.result);if(!x?.pages)throw 0;state=x;state.globalInputFontSize=Math.max(9,Math.min(18,Number(state.globalInputFontSize)||12));PAGES.forEach(p=>state.pages[p.key]=Object.assign(defaults(p.key),state.pages[p.key]||{}));applyGlobalInputFontSize();save();applyAll();select(current)}catch(_){alert('Netinkamas MOGA SF temos failas.')}e.target.value=''};r.readAsText(f)}
function open(k){forceIndividual();applyAll();current=PAGES.some(p=>p.key===k)?k:(activeKey()==='invoice'?'tracking':activeKey());$('#mogaThemeBuilder').classList.add('open');select(current)}function close(){$('#mogaThemeBuilder').classList.remove('open');save();applyAll()}
function init(){load();mount();forceIndividual();applyGlobalInputFontSize();applyAll();
const modalObserver=new MutationObserver(muts=>{
  let needed=false;
  for(const m of muts){
    if(m.type==='childList'&&m.addedNodes.length){needed=true;break}
    if(m.type==='attributes'){needed=true;break}
  }
  if(needed)scheduleModalScope();
});
modalObserver.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','aria-hidden']});
scopeAllModals();setTimeout(applyAll,350);setTimeout(applyAll,1200);setTimeout(applyAll,2600);const old=window.switchPage;if(typeof old==='function'&&!old.__mtbWrapped){const w=function(...a){const r=old.apply(this,a);setTimeout(()=>{forceIndividual();applyAll()},0);return r};w.__mtbWrapped=true;window.switchPage=w}document.body.addEventListener('click',()=>setTimeout(applyAll,40),true)}
window.MOGA_THEME_BUILDER={open,close,apply:applyAll};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();